import Footer from 'components/Footer'
import Header from 'components/Header'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/MainLayout/main-view-layout.module.scss'
import WithDrawer from 'components/UI/withDrawer'
import Nav from 'components/Nav'
import { useSelector } from 'react-redux'
import defaultNavigationConfig from 'constants/default-navigation'

const MainLayout = ({
  children = null,
  noDrawer = false,
  drawerChildren = null,
}) => {
  const { user = {} } = useSelector(({ app }) => app)
  const config = defaultNavigationConfig({ user })

  return (
    <>
      <div id={'drawer-root'} className={styles['drawer-root']} />
      <div className="main-wrapper">
        <Header />
        {!noDrawer && (config.length > 0 || drawerChildren) ? (
          <WithDrawer drawerChildren={drawerChildren ?? <Nav items={config} />}>
            {children}
          </WithDrawer>
        ) : (
          children
        )}
      </div>
      <Footer />
    </>
  )
}

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  drawerChildren: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  noDrawer: PropTypes.bool,
}

export default MainLayout
